module.exports = __webpack_public_path__ + "static/media/logo.aa4e7c28.svg";